if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.quantityBreaks = document.getElementById(`quantity-breaks-${this.dataset.sectionId}`);
        this.customFields = document.querySelectorAll(`[id^='CustomField-${this.dataset.sectionId}-']`);
        this.variantInputs = this.form.querySelector(".product-form__variants");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        if(this.querySelector('.loading__spinner')){
          this.querySelector('.loading__spinner').classList.remove('hidden');
        }
        
        let hasVariants = false;
        if (this.quantityBreaks && this.variantInputs && this.quantityBreaks.formVariants?.length > 0) {
          let quantityInputs = "";
          hasVariants = true;
          for (let i = 0; i < this.quantityBreaks.formVariants.length; i++) {
              let variant = this.quantityBreaks.formVariants[i];
              quantityInputs += `<input type="hidden" name="items[${i}][quantity]" value="${variant.quantity}">`;
              quantityInputs += `<input type="hidden" name="items[${i}][id]" value="${variant.id}">`;
              this.customFields.forEach(field => {
                  quantityInputs += `<input type="hidden" name="items[${i}][properties][${field.fieldName}]" value="${field.value}">`;
              });
          }
          this.variantInputs.innerHTML = quantityInputs;
        }
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        if (hasVariants) {
          let options = this.dataset.options ? this.dataset.options.split(",") : [];
          let fieldsToDelete = ["id", "quantity", ...options];
          for (let field of fieldsToDelete) {
              formData.delete(field);
          }
        }
        config.body = formData;






// --- AVILO OVERRIDE PATCH V9 ---
// Variant ID -> quantity this add asks for, checked against stock below.
let requested = null;
try {
    // 1. Purge ALL default conflicting data 
    let keysToDelete = [];
    for (let key of formData.keys()) {
        if (key === 'id' || key === 'quantity' || key.startsWith('items') || key.includes('Color') || key.includes('\n') || key.includes('\r')) {
            keysToDelete.push(key);
        }
    }
    keysToDelete.forEach(key => formData.delete(key));

    // 2. Build a Title -> ID Map to bypass broken HTML
    let variantMap = {};
    document.querySelectorAll('script[type="application/json"]').forEach(script => {
        try {
            let data = JSON.parse(script.textContent);
            let variants = Array.isArray(data) ? data : (data.variants || (data.product && data.product.variants));
            if (variants && Array.isArray(variants)) {
                variants.forEach(v => { variantMap[v.title.trim()] = v.id; });
            }
        } catch(e) {}
    });

    // 3. The Quantity-Match Firewall
    let activeSelects = [];
    
    // Step A: Find out exactly how many items the user's click requested
    let qtyInput = document.querySelector('input[name="quantity"]:checked') || document.querySelector('input[name="quantity"], select[name="quantity"]');
    let targetQty = qtyInput ? parseInt(qtyInput.value, 10) : 1;

    // Step B: Scan all bundle blocks for the one that perfectly matches that quantity
    let variantContainers = document.querySelectorAll('.quantity-break__variants, .quantity-break-block, [class*="quantity-break"]');
    for (let container of variantContainers) {
        let selects = Array.from(container.querySelectorAll('.quantity-break__variant-select'));
        // If the cart wants 3 items, and this container holds exactly 3 dropdowns, we found our target!
        if (selects.length === targetQty && targetQty > 0) {
            activeSelects = selects;
            break; 
        }
    }

    // 4. Inject the perfect array into the payload
    if (activeSelects.length > 0) {
        let groupedItems = {};
        activeSelects.forEach(select => {
            let selectedText = select.options[select.selectedIndex].text.trim();
            let vId = variantMap[selectedText];
            
            if (!vId) {
                let parentDiv = select.closest('.quantity-break__selector-item');
                vId = parentDiv ? parentDiv.getAttribute('data-selected-id') : null;
            }

            if (vId) groupedItems[vId] = (groupedItems[vId] || 0) + 1;
        });
        requested = groupedItems;

        let i = 0;
        for (let vId in groupedItems) {
            formData.append(`items[${i}][id]`, vId);
            formData.append(`items[${i}][quantity]`, groupedItems[vId]);
            i++;
        }
    } else {
        // Fallback: For standard products like the Summit Range Flask
        let mainId = this.form.querySelector('[name="id"]')?.value || document.querySelector('[name="id"]')?.value;
        if (mainId) {
            formData.append('items[0][id]', mainId);
            formData.append('items[0][quantity]', targetQty);
            requested = { [mainId]: targetQty };

            // NEW: Hunt for custom engraving or other Line Item Properties
            let propsToDelete = [];
            for (let [key, value] of formData.entries()) {
                if (key.startsWith('properties[') && value.trim() !== '') {
                    // Extract the name (e.g., gets "Name" from "properties[Name]")
                    let propName = key.match(/\[(.*?)\]/)[1]; 
                    // Attach it specifically to the flask in the cart
                    formData.append(`items[0][properties][${propName}]`, value);
                    propsToDelete.push(key);
                }
            }
            // Clean up the raw form data so Shopify doesn't get confused
            propsToDelete.forEach(k => formData.delete(k));
        }
    }
} catch (e) {
    console.error("Avilo Patch Error:", e);
}
// --- END OVERRIDE PATCH V9 ---

        // A bundle can ask for more of one colour than is left (every slot starts on the colour
        // picked above it). Shopify would add part of it and answer with an error, so stop here
        // and say what to change instead.
        const stockProblem = this.stockProblem(requested);
        if (stockProblem) {
          this.handleErrorMessage(stockProblem);
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner')?.classList.add('hidden');
          const box = this.errorMessageWrapper?.getBoundingClientRect();
          if (box && (box.top < 0 || box.bottom > window.innerHeight)) {
            this.errorMessageWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return;
        }

        this.skipCart = false;
        if (this.form.querySelector("[type=submit]").dataset.skipCart === "true") {
          this.skipCart = true;
        }

        let cartRendered = false;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.refreshCart();
            //   if (this.skipCart) {
            //     window.location = "/checkout";
            //     return;
            // }

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }else if (this.skipCart) {
                  window.location = "/checkout";
                  return;
              }

            cartRendered = true;
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            // Only after the drawer was re-rendered: on a failed add it still holds the empty-cart
            // markup, and dropping the flag shows it half-built (no items, header at the bottom).
            if (cartRendered && this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            if (this.querySelector('.loading__spinner')){
              this.querySelector('.loading__spinner').classList.add('hidden');
            }
          });
      }

      // Returns a message when `requested` (variant ID -> quantity) needs more of a variant than
      // ds-quantity-breaks says is in stock, otherwise null. Only stock-tracked variants that
      // can't oversell are listed there.
      stockProblem(requested) {
        if (!requested || !this.quantityBreaks?.dataset.stock) return null;
        let stock;
        try {
          stock = JSON.parse(this.quantityBreaks.dataset.stock);
        } catch (e) {
          return null;
        }
        const label = this.quantityBreaks.dataset.stockLabel || 'option';
        for (const id in requested) {
          const variant = stock[id];
          if (!variant || requested[id] <= variant.q) continue;
          if (variant.q <= 0) return `${variant.t} is sold out. Choose another ${label}.`;
          const rest = requested[id] - variant.q;
          return `Only ${variant.q} ${variant.t} left. Choose another ${label} for the other ${rest === 1 ? 'one' : rest}.`;
        }
        return null;
      }

      // A failed add can still have added part of the request (Shopify adds what is in stock and
      // answers 422). Re-render the drawer and count from the server, without opening the drawer,
      // so the page shows what is really in the cart.
      refreshCart() {
        if (!this.cart || typeof this.cart.getSectionDOM !== 'function') return;
        const sections = this.cart.getSectionsToRender();
        fetch(`${routes.cart_url}?sections=${sections.map((section) => section.id).join(',')}`)
          .then((response) => response.json())
          .then((html) => {
            sections.forEach((section) => {
              const element = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);
              if (element && html[section.id]) {
                element.innerHTML = this.cart.getSectionInnerHTML(html[section.id], section.selector);
              }
            });
            // renderContents re-binds the overlay it just replaced; so must this.
            this.cart.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.cart.close.bind(this.cart));
            const fresh = this.cart.getSectionDOM(html['cart-drawer'], 'cart-drawer');
            if (fresh) this.cart.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
          })
          .catch((e) => console.error(e));
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
